import Layout from "../Layouts/Layout.jsx";
import { formatDistanceToNow } from "date-fns";
import useSessionStore from "../stores/sessionStore";

export default function Profile() {
  const user = useSessionStore((state) => state.user);
  return (
    <Layout title="Your Profile">
      <div className="container w-full rounded-xl bg-white shadow p-4 min-h-40">
        <div className="mt-0 border-b border-gray-100">
          <dl className="divide-y divide-gray-100">
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900">Email</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{user.email}</dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900">Last sign in</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                {formatDistanceToNow(new Date(user.last_sign_in_at), { addSuffix: true })}
              </dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900">Role</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{user.profile.role}</dd>
            </div>
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
              <dt className="text-sm/6 font-medium text-gray-900">Team Name</dt>
              <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{user.profile.team_name}</dd>
            </div>
          </dl>
        </div>
      </div>
    </Layout>
  );
};
